import Vue   from 'vue'
import axios from 'axios'
import store from '@/store'

import {VueAxios}            from './axios'
// import {Modal, notification} from 'ant-design-vue'


//创建 axios 实例
const service = axios.create({
    baseURL: '', //api base_url
    timeout: 6000000           //请求超时时间
});
const err = (error) => {
    if (error.response) {
        let data = error.response.data;
       
        switch (error.response.status) {
            case 403:
                // notification.error({message: '系统提示', description: '拒绝访问', duration: 4});
                break;
            case 500:
                
                break;

            case 404:
               // notification.error({message: '系统提示', description: '很抱歉，资源未找到!', duration: 4});
                break;

            case 504:
               // notification.error({message: '系统提示', description: '网络超时'});
                break;

            case 401:
               // notification.error({message: '系统提示', description: '未授权，请重新登录', duration: 4});
                break;
            default:
                break
        }
    }

    return Promise.reject(error)
};
//request interceptor
service.interceptors.request.use(config => {
    const token = localStorage.getItem('t');
    if (token) {
        config.headers['Authorization'] = token    //让每个请求携带自定义 token 请根据实际情况自行修改
    }
    if (config.method === 'get') {
        config.params = {
            _t: Date.parse(new Date()) / 1000,
            ...config.params
        }
    }
    return config
}, (error) => {
    return Promise.reject(error)
});

//response interceptor
service.interceptors.response.use((response) => {
    return response.data
}, err);

const installer = {
    vm: {},
    install(Vue, router = {}) {
        Vue.use(VueAxios, router, service)
    }
};

export {
    service   as axios,
    installer as VueAxios
}
